import { memo } from "react";
import Image from "next/image";
import { conditions } from "../../../../../helpers";
import { IBookmark, ConditionName } from "../../../../../interfaces";
import BookmarkIcon from "../../icon-components/bookmarkIcon";
import { handleBookmark } from "../../../../../redux/actions/user.actions";
import { useAppSelector } from "redux-share";
import { shallowEqual } from "react-redux";

const BookmarkCard = (props: IBookmark) => {
    const date = new Intl.DateTimeFormat("fa", {
        year: "numeric",
        month: "long",
        day: "numeric"
    });

    useAppSelector(({ videoData: { isComplexPortrait } }) => ({ isComplexPortrait }), shallowEqual);

    return (
        <div className="pl-flex pl-items-center pl-max-w-screen pl-cursor-pointer" onClick={() => (window.location.href = props.object_link)}>
            <div
                className={`pl-flex pl-justify-center pl-items-center pl-bg-secondary-50 dark:pl-bg-dark-1 pl-rounded-[2px] pl-ml-1 ${
                    conditions(ConditionName.isComplexPortrait) ? "pl-w-[71px] pl-h-[40px]" : "pl-w-[103px] pl-h-[58px]"
                }`}
            >
                {props.cover_url ? (
                    <Image
                        src={props.cover_url}
                        width={conditions(ConditionName.isComplexPortrait) ? 71 : 103}
                        height={conditions(ConditionName.isComplexPortrait) ? 40 : 58}
                        className="pl-rounded-[2px]"
                    />
                ) : (
                    <BookmarkIcon className="pl-w-8 pl-h-8 pl-fill-main" />
                )}
            </div>
            <div className="pl-flex pl-flex-col pl-justify-between pl-gap-2 pl-flex-1 pl-truncate pl-ml-8">
                <p className={`pl-truncate pl-font-medium ${conditions(ConditionName.isComplexPortrait) ? "pl-text-[11px]" : "pl-text-[14px]"}`}>
                    {props.title}
                </p>
                <p className={`pl-font-medium pl-text-dark-4 ${conditions(ConditionName.isComplexPortrait) ? "pl-text-[9px]" : "pl-text-[10px]"}`}>
                    {date.format(props.created_at * 1000)}
                </p>
            </div>
            <BookmarkIcon
                className="pl-w-4 pl-h-4 pl-fill-gray-800 dark:pl-fill-dark-6 pl-cursor-pointer"
                isBookmark={true}
                onClick={(event: any) => handleBookmark(event, props.id, "delete")}
            />
        </div>
    );
};

export default memo(BookmarkCard);
